import * as React from 'react';

interface TitleProps {
  children?: React.ReactNode[] | React.ReactNode;
}

const Title = ({ children }: TitleProps) => {
  return <h6 className="br-section-label">{children}</h6>;
};

export default Title;
